import React from 'react'
import { Link } from 'react-router-dom'
import Card from '@/components/ui/Card'
import Blob from '@/components/Blob'
import Illustration from '@/components/Illustration'

export default function ContactThanks() {
  return (
    <div className="space-y-12">
      <section className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-shell via-white to-shell px-6 py-12 shadow-soft text-center">
        <Blob className="absolute -top-20 -right-24 h-56 w-56 opacity-30" />
        <Blob className="absolute -bottom-24 -left-16 h-48 w-48 opacity-30" />
        <div className="relative z-10 space-y-4">
          <Illustration name="leaf" className="mx-auto h-20 w-20" animate />
          <h1 className="text-4xl font-semibold tracking-tight text-cocoa">Thank you for reaching out!</h1>
          <p className="text-lg text-cocoa/80">
            We received your message and will respond soon. In the meantime, feel free to explore programs making an impact right now.
          </p>
          <div className="flex flex-wrap justify-center gap-3 pt-2">
            <Link to="/" className="btn bg-white text-cocoa hover:bg-shell">
              Back to Home
            </Link>
            <Link to="/programs" className="btn">
              View Programs
            </Link>
          </div>
        </div>
      </section>

      <Card className="text-center text-sm text-cocoa/70">
        Need to update your message? Email us directly at{' '}
        <a href="mailto:hello@projecttower.org" className="font-medium text-cocoa hover:text-brick transition">
          hello@projecttower.org
        </a>
        .
      </Card>
    </div>
  )
}
